const enum ButtonTypes {
  File = 'file',
  Toggle = 'toggle',
  TileText = 'tileText',
  Close = 'close',
  Options = 'options',
  Date = 'date',
  Icon = 'icon',
  Search = 'searchWrapper',
  Wrapper = 'wrapper'
}

export default ButtonTypes
